import { render, staticRenderFns } from "./dnimportnew.vue?vue&type=template&id=a37721a8&scoped=true&"
import script from "./dnimportnew.vue?vue&type=script&lang=js&"
export * from "./dnimportnew.vue?vue&type=script&lang=js&"
import style0 from "./dnimportnew.vue?vue&type=style&index=0&id=a37721a8&lang=scss&scoped=true&"
import style1 from "./dnimportnew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37721a8",
  null
  
)

export default component.exports